<template lang="pug">
	
	div.alert.alert-dismissible(role='alert', v-if="visible", 
		:class="{'alert-success' : type === 'success','alert-danger' : type === 'error', 'alert-warning' : type === 'warning'}")
		
		strong(v-show="showTitle") {{title}}
		p {{msg}}
		i.close.mdi.mdi-close.action-icon(@click="closeFunction()", v-show="closeFunction")
			
</template>

<script>
export default {
	name: 'Alert',

	props: {

		msg: {
			type: String,
			required: true
		},

		title: {
			type: String,
			default: 'Atenção!'
		},

		showTitle: {
			type: Boolean,
			default: true
		},

		visible: {
			type: Boolean,
			default: true
		},

		closeFunction: {
			type: Function
		},

		type: {
			type: String,
			required: true,
			validator: value => {
				return value === 'error' || value === 'success' || value === 'warning';
			}

		}
	}
};
</script>

<style lang="scss" scoped>

$font-size: 14px;

.alert {
	padding-left: 15px;
	padding-right: 15px;

	&.alert-dismissible .close {
		padding: 0.80rem 0.7rem;
		cursor: pointer;
		font-size: 18px;
	}

	strong {
		padding-bottom: 5px;
	}

	p {
		margin-bottom: 0;
		font-size: $font-size;
	}

	&.alert-sm {
		padding-top: 6px;
		padding-bottom: 6px; 

		&.alert-dismissible .close {
			padding: 0.50rem 0.7rem;
			cursor: pointer;
			font-size: 18px;
		}
	}
}

</style>



// WEBPACK FOOTER //
// Alert.vue?232765c8